import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={12}
      height={6}
      viewBox="0 0 12 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M11.163 5.003a.91.91 0 00-.077-.37.85.85 0 00-.218-.298L6.084.195A.764.764 0 005.578 0a.764.764 0 00-.506.195L.288 4.48a.902.902 0 00-.104 1.208c.136.176.33.286.541.307.21.02.42-.05.584-.195l4.273-3.83 4.273 3.702a.748.748 0 00.853.115.82.82 0 00.334-.32c.08-.14.123-.3.12-.464z"
        fill="#E40046"
      />
    </Svg>
  );
}

export default SvgComponent;
